import React, { useState } from 'react'

const Tooltip = ({ title, className, children }) => {
    const [isVisible, setIsVisible] = useState(false)

    const showTooltip = () => {
        setIsVisible(true)
    }

    const hideTooltip = () => {
        setIsVisible(false)
    }

    return (
        <div
            className='custom-tooltip-container'
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
        >
            {children}
            {isVisible && (
                <div className={`custom-tooltip ${className}`}>{title}</div>
            )}
        </div>
    )
}

export default Tooltip
